import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import isWishlistItemActive from '../../../helpers/is-wishlist-item-active';
var selectListItems = function selectListItems(data) {
  var _data$pages;
  return {
    // Use optional chaining all the way through (matches `select-flat.js`) so
    // a transient cold-cache `data = undefined` doesn't throw — useInfiniteQuery
    // returns undefined on the very first render before the queryFn settles.
    pages: data === null || data === void 0 || (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.reduce(function (accu, current) {
      // Flatten pages for simplicity in consuming components and drop items
      // the wishlists v2 service flagged as not buyable for this marketplace
      // — see `helpers/is-wishlist-item-active.js` for the contract.
      return [].concat(_toConsumableArray(accu), _toConsumableArray(((current === null || current === void 0 ? void 0 : current.objects) || []).filter(isWishlistItemActive)));
    }, []),
    pageParams: data === null || data === void 0 ? void 0 : data.pageParams
  };
};
export default selectListItems;